import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Shield, FileText, Lock } from "lucide-react";

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-[#09090b] text-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#09090b]/90 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <picture><source srcSet="/logo.webp" type="image/webp" /><img src="/logo.png" alt="AURA Gestion" width="32" height="32" className="w-8 h-8 rounded-xl" /></picture>
            <span className="text-xl font-bold">AURA</span>
            <span className="text-violet-400 font-medium">Gestion</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="gap-2 text-zinc-400 hover:text-white">
              <ArrowLeft className="w-4 h-4" />
              Retour
            </Button>
          </Link>
        </div>
      </nav>

      <div className="pt-24 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="w-16 h-16 rounded-2xl bg-violet-500/10 flex items-center justify-center mx-auto mb-6">
              <Shield className="w-8 h-8 text-violet-400" />
            </div>
            <h1 className="text-4xl font-bold mb-4">Mentions Légales</h1>
            <p className="text-zinc-400">Dernière mise à jour : Mars 2026</p>
          </div>

          {/* Content */}
          <div className="space-y-12">
            {/* Éditeur */}
            <section className="p-8 rounded-2xl bg-zinc-900/50 border border-zinc-800">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-6 h-6 text-violet-400" />
                <h2 className="text-2xl font-bold">Éditeur du site</h2>
              </div>
              <div className="space-y-3 text-zinc-300">
                <p><span className="text-zinc-500">Raison sociale :</span> <strong>AURA</strong></p>
                <p><span className="text-zinc-500">SIRET :</span> 903 058 352 00035</p>
                <p><span className="text-zinc-500">Siège social :</span> 47 rue principale, 67690 Hatten, France</p>
                <p><span className="text-zinc-500">Email :</span> <a href="mailto:auradigital149@gmail.com" className="text-violet-400 hover:underline">auradigital149@gmail.com</a></p>
                <p><span className="text-zinc-500">Directeur de publication :</span> AURA</p>
              </div>
            </section>

            {/* Hébergement */}
            <section className="p-8 rounded-2xl bg-zinc-900/50 border border-zinc-800">
              <div className="flex items-center gap-3 mb-6">
                <Shield className="w-6 h-6 text-emerald-400" />
                <h2 className="text-2xl font-bold">Hébergement</h2>
              </div>
              <div className="space-y-3 text-zinc-300">
                <p>Le site aura-gestion.fr est hébergé par :</p>
                <p><strong>Emergent / Cloud Infrastructure</strong></p>
                <p>Les données sont stockées sur des serveurs sécurisés situés en Union Européenne.</p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section className="p-8 rounded-2xl bg-zinc-900/50 border border-zinc-800">
              <h2 className="text-2xl font-bold mb-6">Propriété intellectuelle</h2>
              <div className="space-y-4 text-zinc-300 leading-relaxed">
                <p>
                  L'ensemble du contenu du site AURA Gestion (textes, images, logos, icônes, logiciels) 
                  est la propriété exclusive d'AURA ou de ses partenaires et est protégé par les lois 
                  françaises et internationales relatives à la propriété intellectuelle.
                </p>
                <p>
                  Toute reproduction, représentation, modification, publication ou adaptation de tout 
                  ou partie des éléments du site est interdite sans autorisation écrite préalable.
                </p>
              </div>
            </section>

            {/* CGU */}
            <section id="cgu" className="p-8 rounded-2xl bg-zinc-900/50 border border-zinc-800">
              <h2 className="text-2xl font-bold mb-6">Conditions Générales d'Utilisation (CGU)</h2>
              <div className="space-y-4 text-zinc-300 leading-relaxed">
                <h3 className="text-lg font-semibold text-white">1. Objet</h3>
                <p>
                  Les présentes CGU ont pour objet de définir les conditions d'accès et d'utilisation 
                  du service AURA Gestion, application de facturation en ligne.
                </p>

                <h3 className="text-lg font-semibold text-white">2. Accès au service</h3>
                <p>
                  L'accès au service nécessite la création d'un compte utilisateur. L'utilisateur 
                  s'engage à fournir des informations exactes et à maintenir la confidentialité 
                  de ses identifiants.
                </p>

                <h3 className="text-lg font-semibold text-white">3. Description du service</h3>
                <p>
                  AURA Gestion permet de créer, gérer et envoyer des factures et devis professionnels 
                  conformes à la réglementation française. Le service inclut la génération de PDF, 
                  l'envoi par email et le suivi des paiements.
                </p>

                <h3 className="text-lg font-semibold text-white">4. Responsabilités de l'utilisateur</h3>
                <p>
                  L'utilisateur est seul responsable des informations qu'il saisit dans ses documents. 
                  Il lui appartient de vérifier la conformité légale de ses factures et de ses pratiques 
                  commerciales.
                </p>

                <h3 className="text-lg font-semibold text-white">5. Tarification</h3>
                <p>
                  AURA Gestion propose un plan gratuit et des plans payants. Les tarifs sont indiqués 
                  sur la page Tarifs. Tout abonnement est résiliable à tout moment depuis l'espace client.
                </p>

                <h3 className="text-lg font-semibold text-white">6. Limitation de responsabilité</h3>
                <p>
                  AURA ne saurait être tenu responsable des dommages directs ou indirects résultant 
                  de l'utilisation du service, notamment en cas d'erreur dans les documents générés 
                  par l'utilisateur.
                </p>
              </div>
            </section>

            {/* CGV */}
            <section id="cgv" className="p-8 rounded-2xl bg-zinc-900/50 border border-zinc-800">
              <h2 className="text-2xl font-bold mb-6">Conditions Générales de Vente (CGV)</h2>
              <div className="space-y-4 text-zinc-300 leading-relaxed">
                <h3 className="text-lg font-semibold text-white">1. Offres et tarifs</h3>
                <p>
                  Les abonnements AURA Solo (19€/mois ou 190€/an) et AURA Expert BTP (49€/mois ou 490€/an) 
                  donnent accès aux fonctionnalités premium décrites sur la page Tarifs.
                </p>

                <h3 className="text-lg font-semibold text-white">2. Modalités de paiement</h3>
                <p>
                  Le paiement s'effectue par carte bancaire via notre prestataire sécurisé Stripe. 
                  L'abonnement est reconduit automatiquement sauf résiliation préalable.
                </p>

                <h3 className="text-lg font-semibold text-white">3. Droit de rétractation</h3>
                <p>
                  Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation 
                  ne s'applique pas aux services pleinement exécutés avant la fin du délai de rétractation.
                </p>

                <h3 className="text-lg font-semibold text-white">4. Résiliation</h3>
                <p>
                  L'utilisateur peut résilier son abonnement à tout moment depuis son espace client. 
                  La résiliation prend effet à la fin de la période de facturation en cours.
                </p>
              </div>
            </section>

            {/* RGPD */}
            <section id="rgpd" className="p-8 rounded-2xl bg-zinc-900/50 border border-zinc-800">
              <div className="flex items-center gap-3 mb-6">
                <Lock className="w-6 h-6 text-blue-400" />
                <h2 className="text-2xl font-bold">Politique de Confidentialité (RGPD)</h2>
              </div>
              <div className="space-y-4 text-zinc-300 leading-relaxed">
                <h3 className="text-lg font-semibold text-white">1. Responsable du traitement</h3>
                <p>
                  AURA, située au 47 rue principale, 67690 Hatten, est responsable du traitement 
                  des données personnelles collectées sur ce site.
                </p>

                <h3 className="text-lg font-semibold text-white">2. Données collectées</h3>
                <p>Nous collectons les données suivantes :</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Données d'identification : nom, email, mot de passe (chiffré)</li>
                  <li>Données professionnelles : SIRET, adresse, informations de facturation</li>
                  <li>Données de vos clients : nom, email, adresse (pour la facturation)</li>
                  <li>Données de paiement : traitées par Stripe, non stockées par AURA</li>
                </ul>

                <h3 className="text-lg font-semibold text-white">3. Finalités du traitement</h3>
                <p>Vos données sont utilisées pour :</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>La gestion de votre compte et la fourniture du service</li>
                  <li>La génération de vos factures et devis</li>
                  <li>L'envoi de communications relatives au service</li>
                  <li>Le respect de nos obligations légales et comptables</li>
                </ul>

                <h3 className="text-lg font-semibold text-white">4. Durée de conservation</h3>
                <p>
                  Les données sont conservées pendant la durée de votre abonnement, puis 10 ans 
                  pour les documents comptables (obligation légale).
                </p>

                <h3 className="text-lg font-semibold text-white">5. Vos droits</h3>
                <p>Conformément au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement ("droit à l'oubli")</li>
                  <li>Droit à la portabilité de vos données</li>
                  <li>Droit d'opposition au traitement</li>
                </ul>
                <p className="mt-4">
                  Pour exercer ces droits, contactez-nous à : 
                  <a href="mailto:auradigital149@gmail.com" className="text-violet-400 hover:underline ml-1">
                    auradigital149@gmail.com
                  </a>
                </p>

                <h3 className="text-lg font-semibold text-white">6. Sécurité</h3>
                <p>
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées 
                  pour protéger vos données : chiffrement des mots de passe, connexion HTTPS, 
                  accès restreint aux bases de données.
                </p>

                <h3 className="text-lg font-semibold text-white">7. Cookies</h3>
                <p>
                  AURA Gestion utilise uniquement des cookies techniques nécessaires au fonctionnement 
                  du service (authentification). Aucun cookie publicitaire ou de traçage n'est utilisé.
                </p>
              </div>
            </section>

            {/* Contact */}
            <section className="p-8 rounded-2xl bg-gradient-to-br from-violet-500/10 to-purple-500/10 border border-violet-500/20">
              <h2 className="text-2xl font-bold mb-4">Une question ?</h2>
              <p className="text-zinc-300 mb-6">
                Pour toute question relative à ces mentions légales ou à vos données personnelles, 
                n'hésitez pas à nous contacter.
              </p>
              <a href="mailto:auradigital149@gmail.com">
                <Button className="bg-violet-600 hover:bg-violet-500">
                  Nous contacter
                </Button>
              </a>
            </section>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-zinc-800 py-8 px-6">
        <div className="max-w-4xl mx-auto text-center text-zinc-500 text-sm">
          <p>© 2026 AURA Gestion. Tous droits réservés.</p>
          <p className="mt-2">SIRET : 903 058 352 00035 | 47 rue principale, 67690 Hatten</p>
        </div>
      </footer>
    </div>
  );
}
